(() => {
  const KEY = 'aware-collection-filters-hidden';

  const getState = () => {
    try {
      return sessionStorage.getItem(KEY) === 'true';
    } catch (_) {
      return false;
    }
  };

  const setState = (hidden) => {
    try {
      sessionStorage.setItem(KEY, hidden ? 'true' : 'false');
    } catch (_) {}
  };

  const syncWrapper = (wrapper, hidden = getState()) => {
    if (!(wrapper instanceof HTMLElement)) return;

    wrapper.classList.toggle('aware-filters-hidden', hidden);

    wrapper.querySelectorAll('[data-aware-filter-toggle]').forEach((button) => {
      const expanded = hidden ? 'false' : 'true';

      if (button.getAttribute('aria-expanded') !== expanded) {
        button.setAttribute('aria-expanded', expanded);
      }

      const label = button.querySelector('[data-aware-filter-toggle-label]');
      const text = hidden ? 'Show filters' : 'Hide filters';

      if (label && label.textContent !== text) {
        label.textContent = text;
      }
    });
  };

  const syncAll = () => {
    document
      .querySelectorAll('.collection-wrapper')
      .forEach((wrapper) => syncWrapper(wrapper));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-aware-filter-toggle]');
    if (!button) return;

    const wrapper = button.closest('.collection-wrapper');
    if (!wrapper) return;

    const hidden = !wrapper.classList.contains('aware-filters-hidden');

    setState(hidden);
    syncWrapper(wrapper, hidden);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }

  let scheduled = false;

  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) =>
      [...mutation.addedNodes].some((node) => {
        if (!(node instanceof Element)) return false;

        return (
          node.matches('.collection-wrapper') ||
          node.querySelector('.collection-wrapper') ||
          node.parentElement?.closest('.collection-wrapper')
        );
      })
    );

    if (!relevant || scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      syncAll();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();